import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'antd'
import {HomeTwoTone} from '@ant-design/icons';
import './index.css'
const ModalBox = ({ children, title,okText,visible, onSubmit, onCancel, width, footer, loading,cname }) => {
    return (
        <div>
            <Modal
                title={title}
                open={visible}
                maskClosable={false}
                okText="确定"
                cancelText="取消"
                destroyOnClose={true}
                forceRender={false}
                onOk={() => onSubmit()}
                onCancel={() => onCancel()}
                width={width ? width : 600}
                confirmLoading={loading}
				footer={footer}
            >	
		
				<div style={{position: 'absolute',left:'50px',top:'70px',fontWeight:'500'}}>
					{cname}
					
				</div>
		
                {children}
            </Modal>
        </div>
    )
}
ModalBox.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.node,
    ]),
    title: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func.isRequired,
    width: PropTypes.number


}
export default ModalBox
